module.exports = __webpack_public_path__ + "static/img/1958_09_24_KonerStadt-Anzeiger.1c4abbb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cage/archive/1958_09_24_KonerStadt-Anzeiger.jpg
// module id = dK+n
// module chunks = 0